// The size chart popup. With youth and adult charts, it opens on the one for the size the shopper picked.
(function () {
  var dialog = document.querySelector('[data-size-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  var title = dialog.querySelector('[data-size-dialog-title]');
  var body = dialog.querySelector('[data-size-dialog-body]');
  var tabs = dialog.querySelector('[data-size-dialog-tabs]');
  var tabButtons = tabs ? Array.prototype.slice.call(tabs.querySelectorAll('[data-tab]')) : [];
  var current = null;
  var lastFocus = null;

  function show(which) {
    if (!current) return;
    var tpl = current.querySelector('[data-chart-' + which + ']');
    if (!tpl) return;
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    tabButtons.forEach(function (b) {
      var on = b.dataset.tab === which;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-size-chart-open]');
    if (!link) return;
    e.preventDefault();
    current = link.closest('[data-size-chart]');
    if (!current) return;
    var youth = current.querySelector('[data-chart-youth]');
    var adult = current.querySelector('[data-chart-adult]');
    var both = !!(youth && adult);
    if (tabs) tabs.hidden = !both;
    var row = link.closest('[data-bundle-item]') || link.closest('form');
    var picked = row ? row.querySelector('[data-bundle-size], select[name="id"], [data-size-select]') : null;
    var value = picked ? String(picked.value || (picked.options && picked.options[picked.selectedIndex] && picked.options[picked.selectedIndex].text) || '') : '';
    var start = adult ? 'adult' : 'youth';
    if (both && /^(Y|J)/i.test(value.trim())) start = 'youth';
    title.textContent = link.dataset.chartName || '';
    show(start);
    lastFocus = link;
    dialog.showModal();
  });

  tabButtons.forEach(function (b) {
    b.addEventListener('click', function () { show(b.dataset.tab); });
  });
  dialog.addEventListener('click', function (e) {
    // A click on the backdrop (the dialog itself, outside its box) closes it.
    if (e.target === dialog || e.target.closest('[data-size-dialog-close]')) dialog.close();
  });
  dialog.addEventListener('close', function () {
    body.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  });
})();
